import './navHome.css';

export default function NavHome() {
    return(
        <div>
            <svg width="27.62" height="25" viewBox="0 0 27.62 25">
                <path id="Icon_material-round-home" data-name="Icon material-round-home" d="M10.8,23.5V15.994h6V23.5a1.505,1.505,0,0,0,1.5,1.5h4.5a1.505,1.505,0,0,0,1.5-1.5V12.992h2.552a.745.745,0,0,0,.5-1.306L14.812.383a1.513,1.513,0,0,0-2.011,0L.252,11.686a.747.747,0,0,0,.5,1.306H3.3V23.5A1.505,1.505,0,0,0,4.8,25H9.3A1.505,1.505,0,0,0,10.8,23.5Z" fill="#88cdf6"/>
            </svg>
        </div>
    )
}